module.exports = __webpack_public_path__ + "img/missionaries1_2019_7-7-2021.7d8231b2.jpg";